<script>
	import { onMount, afterUpdate } from 'svelte';
	import Shelf from './shelf.svelte';
	import Loader from './loader.svelte';

	export let t;
	export let profile;
	export let userLink;
	export let HOST;
	export let getUserShelvesApi;

	let shelves;
	let books;
	let shelvesEl;
	let shelfIndexesToShow;

	let mediaImgPath = '/public/iframe/assets/img/';
	let loadingImg = HOST + mediaImgPath + "loading.svg";
	let whiteLogoImg = HOST + mediaImgPath + "MyBlio-logo-white.png";
	let noCover = HOST + mediaImgPath + "no-cover.png";

	let hash = window.location.hash;

	let regHash = new RegExp(/^#s(\d+(?:\+\d+)*)/, 'i')

	onMount(async () => {
		const res = await fetch(`${getUserShelvesApi}?userId=${profile.id}`);
		const json = await res.json();
		shelves = json.shelves;
		books = json.books;
		shelfIndexesToShow = (() => {
			if(hash && regHash.test(hash)) {
				const matchIndexes = hash.match(regHash);
				if(matchIndexes && matchIndexes.length && matchIndexes[1]) {
					let indexes = matchIndexes[1].split('+');
					indexes = indexes.filter(index => /\d+/.test(index)).map(index => parseInt(index)).filter(index => index);
					if(indexes.length) {
						return indexes;
					}
				}
			}
			return
		})()
	});

	afterUpdate(checkBookWidthsAreTheSame)

	function checkBookWidthsAreTheSame() {
	  	let bookEls = shelvesEl.querySelectorAll('.books a');
	  	let bookWidths = []
	  	for(let i=0; bookEls.length > i; i++) {
	  		bookEls[i].style.maxWidth = null;
	  		bookWidths.push(bookEls[i].getBoundingClientRect().width);
	  	}
	  	bookWidths = bookWidths.sort((a,b) => a > b)
	  	for(let ii=0; bookEls.length > ii; ii++) {
	  		if(bookEls[ii].getBoundingClientRect().width > bookWidths[0]) {
	  			bookEls[ii].style.maxWidth = bookWidths[0] + "px"
	  		}
	  	}
	}

	window.onresize = checkBookWidthsAreTheSame;

</script>

<main>
	<header>
        <a href={ userLink } target="_blank" class="logo">
        	<img alt="MyBlio logo" src="{whiteLogoImg}">
        </a>
        <h1 class="header-title">
            <strong>{ profile.nickname }</strong> <br class="br-1" />{ t['sharesBooks'] } <br class="br-2" /> 
            <span class="header-link">{ t['sharesBooksOn'] } <a href={HOST}>Mybl.io</a><span>
        </h1>
    </header>
	<div class="shelves" bind:this={shelvesEl}>
		{#if shelves && books}
			{#each shelves as shelf, i}
				{#if shelfIndexesToShow === undefined || (shelfIndexesToShow !== undefined && shelfIndexesToShow.includes(i+1))}
					<Shelf shelf={ shelf } t={t} books={ books } noCover={noCover} />
				{/if}
			{:else}
				<div class="no-shelves">
					<p>{ t['noContentToDisplay'] }</p>
				</div>
			{/each}
		{:else}
			<Loader img={loadingImg} />
		{/if}
	</div>
	<footer>
		<h3>{ t['poweredBy'] } <a href="{HOST}">MyBl.io</a><br />
		{ t['madeBy'] } <a href="https://elpats.com">Elpats</a>
		</h3>
	</footer>
</main>

<style>
	:global(html), :global(body) {
		position: relative;
		width: 100%;
		height: 100%;
	}
	:global(body) {
		background-color: #fff;
		color: #333;
		margin: 0;
		padding: 0;
		padding-top: 42px;
		box-sizing: border-box;
		font-family: 'Montserrat', sans-serif;
		font-weight: 400;
	}
	:global(a) {
		color: #EE6666;
		text-decoration: none;
	}
	header {
		background-color: #222;
		position: fixed;
		z-index: 1;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		height: 32px;
		padding: 5px 18px;
	}
	.logo {
		margin-right: auto;
		margin-top: 4px;
	}
	.logo img {
		height: 23px
	}
	.header-title {
		font-size: 11px;
		line-height: 16px;
		font-weight: 400;
		color: #fff;
		margin: 0;
		margin-left: auto;
		text-align: right;
	}
	.header-title strong {
		font-weight: 500;
	}
	.header-title a {
		color: #fafafa;
	}
	.header-title .br-1 {
		display: none;
	}
	.shelves {
		margin: 15px 8px 0;
	}
	.no-shelves {
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center; 
	}
	footer {
		border-top: 1px solid #e1e1e1;
		padding: 30px 0;
		margin: 40px 20px 0;
		margin-top: 40px;
		text-align: center;
		font-size: 0.8em;
		line-height: 1.8;
		color: #666;
	}
	footer h3 {
		font-weight: 400;
	}
	@media (max-width: 400px) {
		.logo img {
			margin-top: 3px;
			height: 20px;
		}
		header {
			padding-left: 12px;
			padding-right: 12px;
			padding: 5px 12px;
		}
		.shelves {
			margin-left: 4px;
			margin-right: 4px
		}
		.header-title .br-1 {
			display: inline;
		}
		.header-title .br-2,
		.header-title .header-link {
			display: none;
		}
	}
	@media (max-width: 300px) {
		.logo img {
			margin-top: 3px;
			height: 18px;
		}
	}
</style>